module.exports = __webpack_public_path__ + "static/logo-bethel-05de5ff4287c7630461ea911817b993d.png";